export default "__VITE_ASSET__1078dd7e__"